export default function faq() {

	const $ = jQuery;

	let faqItems = document.querySelectorAll('.faq .faq__question');

	if(!faqItems.length) return;


	faqItems.forEach((item) => {
		item.addEventListener('click', function() {
			this.classList.toggle('active');
			// Slide toggle sibling .faq__answer
			$(this.nextElementSibling).slideToggle();
		});
	});
}